import { WORK_REGISTER_CODES } from '../../config/settings/constant'
import {
  GET_MINVU_REGISTRY,
  GET_MINVU_REGISTRY_ERROR,
  GET_MINVU_REGISTRY_SUCCESS,
  LOAD_INITIAL_REGISTRIES,
  LOAD_INITIAL_REGISTRIES_ERROR,
  LOAD_INITIAL_REGISTRIES_SUCCESS,
  GET_MOP_REGISTRY,
  GET_MOP_REGISTRY_ERROR,
  GET_MOP_REGISTRY_SUCCESS
} from './WorkRegister.actions'

const initialState = {
  error: null,
  loading: false,
  minvu: {
    consultants: {
      data: null,
      searching: false
    },
    contractors: {
      data: null,
      searching: false
    }
  },
  mop: {
    consultants: {
      data: null,
      searching: false
    },
    contractors: {
      data: null,
      searching: false
    }
  }
}

/**
 * The work register reducer.
 */
const workRegisterReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_MINVU_REGISTRY: {
      return {
        ...state,
        minvu: {
          consultants: {
            ...state.minvu.consultants,
            searching: payload?.registerCode === WORK_REGISTER_CODES.CONSULTANTS
          },
          contractors: {
            ...state.minvu.contractors,
            searching: payload?.registerCode === WORK_REGISTER_CODES.CONTRACTORS
          }
        }
      }
    }
    case GET_MINVU_REGISTRY_ERROR: {
      return {
        ...initialState,
        error: payload.error
      }
    }
    case GET_MINVU_REGISTRY_SUCCESS: {
      return {
        ...state,
        minvu: {
          ...state.minvu,
          [payload.registryCodeKey]: {
            data: payload[payload.registryCodeKey],
            searching: false
          }
        }
      }
    }
    case LOAD_INITIAL_REGISTRIES: {
      return {
        ...initialState,
        loading: true
      }
    }
    case LOAD_INITIAL_REGISTRIES_ERROR: {
      return {
        ...initialState,
        error: payload.error
      }
    }
    case LOAD_INITIAL_REGISTRIES_SUCCESS: {
      return {
        ...state,
        minvu: {
          consultants: {
            ...initialState.minvu.consultants,
            data: payload.consultants
          },
          contractors: {
            ...initialState.minvu.contractors,
            data: payload.contractors
          }
        },
        mop: {
          consultants: {
            ...initialState.mop.consultants,
            data: payload.consultantsMop,
            registration: payload.consultantsMop.registration
          },
          contractors: {
            ...initialState.mop.contractors,
            data: payload.contractorsMop,
            registration: payload.contractorsMop.registration
          }
        },
        loading: false,
        error: null
      }
    }
    case GET_MOP_REGISTRY: {
      return {
        ...state,
        mop: {
          ...state.mop,
          consultants: {
            ...state.mop.consultants,
            searching: payload?.registerCode === WORK_REGISTER_CODES.CONSULTANTS
          },
          contractors: {
            ...state.mop.contractors,
            searching: payload?.registerCode === WORK_REGISTER_CODES.CONTRACTORS
          }
        }
      }
    }
    case GET_MOP_REGISTRY_ERROR: {
      return {
        ...state,
        error: payload.error
      }
    }
    case GET_MOP_REGISTRY_SUCCESS: {
      return {
        ...state,
        mop: {
          ...state.mop,
          [payload.registryCodeKey]: {
            ...(state.mop[payload.registryCodeKey] ?? {}),
            data: payload[payload.registryCodeKey],
            searching: false
          }
        }
      }
    }
    default: {
      return state
    }
  }
}

export default workRegisterReducer
